import { OnChangeTimezone, 
         OnChangeTimezoneSearch } from './OnChangeTimezone'
import { OnChangeCountry  }       from './OnChangeCountry'
import { OnChangeProvince }       from './OnChangeProvince'


export const OnSchedOnChange = { 
  OnChangeTimezone, 
  OnChangeTimezoneSearch,
  OnChangeCountry,
  OnChangeProvince
}
